import { Component, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { CONSTS } from './ftp-scan-events-setting.constants';

@Component({
  selector: 'app-ftp-scan-events-setting',
  templateUrl: './ftp-scan-events-setting.component.html',
  styleUrl: './ftp-scan-events-setting.component.scss',
  standalone: false,
})
export class FtpScanEventsSettingComponent {
  @Input({ required: true }) form!: FormGroup;

  readonly CONSTANTS = CONSTS;
  readonly IMAGES = IMAGE_SRC;

  constructor(private fb: FormBuilder) {}

  addFtpScanRow() {
    const newVal = this.fb.group({
      id: 0,
      locationId: 0,
      isftps: false,
      isSecureftp: [false],
      hostName: [''],
      directory: [''],
      userName: [''],
      password: [''],
      sftpPortnum: [''],
    });
    this.getArray.push(newVal);
  }

  deleteFtpScanRow(index: number) {
    if (this.getArray.length > 1) {
      this.getArray.removeAt(index);
    } else {
      this.getArray.controls[index]?.reset();
    }
    this.getArray.markAsTouched();
    this.getArray.markAsDirty();
  }

  get getArray() {
    return this.form.get('ftpEvents') as FormArray;
  }
}
